import {browserBaseFontSize} from "./BrowserBaseFontSize.const";
import {baseFontSizePercentage} from "./BaseFontSizePercentage.const";

export const fontSizeRemDivision = browserBaseFontSize * (baseFontSizePercentage / 100);
